import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const AddServices = createAsyncThunk(
  "AddServices",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/Add-VendorService-info`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("response---------->", response);
      toast.success("Service added successfully, Please check your Email and Approve in Mail", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to add service",
        toast_config
      ); // Notify error with toast notification
      return rejectWithValue(error);
    }
  }
);

export const SearchServices = createAsyncThunk(
  "SearchServices",
  async (formData, { rejectWithValue }) => {
    console.log("Form Data:", formData);

    try {
      // const token = localStorage.getItem("token");

      // if (!token) {
      //   console.error("❌ No token found in localStorage");
      //   return rejectWithValue("Token not found");
      // }

      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/SearchServices`,
        formData,
        {
          headers: {
            // "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("❌ API Error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);



export const DeleteServices = createAsyncThunk(
  "DeleteServices",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/v1/VendorManagement/Delete-Vendor-Service/${ID}`
      );
      toast.success("Service Delete successfully", toast_config);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ShowVendorServices = createAsyncThunk(
  "ShowVendorServices",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/VendorManagement/show-Vendor-Service/${ID}`
      );
      console.log("ShowVendorServices",response.data.data);
      
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const UpdateServices = createAsyncThunk(
  "UpdateServices",
  async (formValues, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/VendorManagement/Update-Vendor-Service`,
        formValues,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Service Update successfully", toast_config);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const ServiceManagementSlice = createSlice({
  name: "ServiceManagementSlice",
  initialState: {
    Data: [],
    IsAdding: false,
    loading: false,
    error: null,
  },
  reducers: {
    IsAddingOpen: (state, action) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state, action) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddServices.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(SearchServices.pending, (state) => {
        state.loading = true;
      })
      // .addCase(SearchServices.fulfilled, (state, action) => {
      //   console.log(action.payload.VendorServices);
      //   state.loading = false;
      //   state.Data = action.payload.VendorServices;
      // })

      .addCase(SearchServices.fulfilled, (state, action) => {
        state.loading = false;
        console.log("SearchServices response:", action.payload.VendorServices); // Debugging output
      
        if (action.payload && action.payload.VendorServices) {
          state.Data = action.payload.VendorServices;
        } else {
          state.Data = []; // Ensures state does not break
          console.error("⚠️ VendorServices not found in API response");
        }
      })
      

      .addCase(ShowVendorServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowVendorServices.fulfilled, (state, action) => {
        console.log(action.payload.VendorServices);
        state.loading = false;
        state.Data = action.payload.VendorServices;
      })

      .addCase(DeleteServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteServices.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(UpdateServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateServices.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addMatcher(
        (action) =>
          action.type.endsWith("/rejected") && action.meta.rejectedWithValue,
        (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
        }
      );
  },
});

export const { IsAddingOpen } = ServiceManagementSlice.actions;
export default ServiceManagementSlice.reducer;
